import React from 'react'
import { useSelector } from 'react-redux'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { Box, Typography } from 'transfix-ui/core'
import { ICarrierState } from 'types/carrier'
import { useUserDetails } from 'utils/hooks/useUserDetails'
import { IStore } from 'apps/carrier/utils/reducers'
import { CollapsibleSection } from '../../CollapsibleSection'
import { ValueField } from '../../ValueField'
import EntityTypeField from './EntityTypeField'
import { useCompanyInformationQuery } from './graphql/CompanyInformation'
import { getMaskedEin } from './utils'

export const CompanyInformation = () => {
  const { carrierDetails } = useSelector<IStore, ICarrierState>(({ carrier }) => carrier)
  const { id: carrierId = '' } = carrierDetails || {}
  const { userPermissions } = useUserDetails()
  const { canEditComplianceCarrierInfo } = userPermissions || {}
  const { data, error, loading, refetch } = useCompanyInformationQuery({
    variables: { carrierApplicationId: carrierId },
  })

  const { carrierApplication, highwayCarrier } = data || {}

  const { dbaName, dotNumber, ein, legalName, mcNumber } = highwayCarrier || {}
  const { entityType, id: carrierApplicationId } = carrierApplication || {}

  const maskedEin = canEditComplianceCarrierInfo ? ein : getMaskedEin(ein || '')

  const Title = () => <Typography variant='subtitle1'>Information</Typography>

  return (
    <CollapsibleSection Title={Title} defaultOpen>
      {error && <InlineMessage message={error.message} type={INLINE_MESSAGE_VARIANTS.ALERT} />}
      <Box display='grid' gridTemplateColumns='1fr 1fr' gap='12px'>
        <ValueField title='Legal Name' value={legalName} loading={loading} />
        <ValueField title='EIN' value={maskedEin} loading={loading} />
        <ValueField title='MC Number' value={mcNumber} loading={loading} />
        <ValueField title='DBA' value={dbaName} loading={loading} />
        <ValueField title='DOT Number' value={dotNumber} loading={loading} />
      </Box>
      <EntityTypeField
        entityType={entityType}
        carrierApplicationId={carrierApplicationId}
        refetch={refetch}
      />
    </CollapsibleSection>
  )
}
